import React from 'react';
import { ChakraV3 } from '..';

export const Dot = (props: ChakraV3.SquareProps) => {
  return <ChakraV3.Circle {...props} />;
};
